import { BitmapText, Container, Graphics, Sprite, Text, withPixiApp } from '@inlet/react-pixi'
import React, { Component } from "react";
import UIManager from "./UiBuilder";
import { Tween } from "../effect/tween"


interface IProps {
    [x: string]: any;

    // loader: {
    //     config: {string:string}
    // }
}

interface IState {
    textElement: any
}

class UINumberText extends React.Component<IProps, IState> {
    protected textObj: any;
    protected ticking: boolean;
    private tickupRequest: any;
    private tweening: any;
    private fpsInterval: any;
    private then: any;

    constructor(props: IProps) {
        super(props);
        this.textObj = {};
        this.tweening = [];
        this.ticking = false;
        this.fpsInterval = 1000 / this.props.tickupspeed;
        this.tick();
    }

    componentDidMount() {

        this.fitText();
        this.createtext();
        this.addText();
        // this.startTickup(this.props.tickupStopValue || 1);
        //this.startTickup(10000);


    }

    toFixed(num: number, fixed: number) {
        fixed = fixed || 0;
        fixed = Math.pow(10, fixed);
        // return Math.floor(num * fixed) / fixed;
        return ((num * fixed) / fixed).toFixed(2);
    };

    reset() {
        this.textObj.count = 0;
        this.textObj.value = this.props.value;
        this.textObj.text = this.props.prefix + this.props.value + this.props.postfix;
    }

    startTickup(finalvalue: number = 0) {
        this.ticking = true;
        // this.textObj.text = this.props.prefix + this.props.value + this.props.postfix;
        // this.textObj.value = this.props.value;

        const now = Date.now();
        this.then = now;


        if (this.props.numberaddup) {
            this.textObj.value = this.textObj.value;
        } else {
            this.reset();
        }

        if (this.props.runonvalue) {
            this.tweenTo(this.textObj, "value", finalvalue, this.textObj.tickuptime, this.easeInSine(1), (e: any) => {
                this.textObj && (e.time = this.textObj.tickuptime);
                const now = Date.now();
                const elapsed = now - this.then;
                if (elapsed > this.fpsInterval && this.textObj) {
                    if (this.toFixed(this.textObj.count, 0) >= e.target) {
                        this.textObj.count = e.target;
                    } else {
                        this.textObj.count += this.toFixed(this.props.tickupvalue, this.props.decimaldigit)
                    }
                    this.textObj.value = this.textObj.count;

                    if (this.textObj.updateTextFromOutside == undefined || this.textObj.updateTextFromOutside == false) {
                        this.textObj.text = this.props.prefix + this.toFixed(this.textObj.value, this.props.decimaldigit) + this.props.postfix;

                    }
                    this.fitText();
                    this.props.tickupupdate && this.props.tickupupdate(this.textObj)
                    this.then = now - (elapsed % this.fpsInterval);
                }


            }, (e: any) => {
                const now = Date.now();
                if (this.textObj) {
                    if (this.textObj.updateTextFromOutside == undefined || this.textObj.updateTextFromOutside == false) {
                        this.textObj.text = this.props.prefix + this.toFixed(e.target, this.props.decimaldigit) + this.props.postfix;

                    }
                }
                // this.fitText();
                this.stopTickup();
            })
        } else {
            this.tweenTo(this.textObj, "value", finalvalue, this.textObj.tickuptime, this.easeInSine(1), (e: any) => {
                this.textObj && (e.time = this.textObj.tickuptime);
                const now = Date.now();
                const elapsed = now - this.then;
                if (elapsed > this.fpsInterval && this.textObj) {
                    if (this.toFixed(this.textObj.value, 0) >= e.target) {
                        this.textObj.value = e.target;

                        //this.props.onTickupComplete();
                    }
                    this.props.tickupupdate && this.props.tickupupdate(this.textObj)
                    if (this.textObj.updateTextFromOutside == undefined || this.textObj.updateTextFromOutside == false) {
                        this.textObj.text = this.props.prefix + this.toFixed(this.textObj.value, this.props.decimaldigit) + this.props.postfix;

                    }
                    this.fitText();
                    this.then = now - (elapsed % this.fpsInterval);
                }



            }, (e: any) => {
                const now = Date.now();
                if (this.textObj) {
                    if (this.textObj.updateTextFromOutside == undefined || this.textObj.updateTextFromOutside == false) {
                        this.textObj.text = this.props.prefix + this.toFixed(e.target, this.props.decimaldigit) + this.props.postfix;

                    }
                }
                // this.fitText();
                this.stopTickup();
                //this.props.onTickupComplete();
            })
        }

    }



    stopTickup() {
        this.ticking = false;
        if (this.textObj) {
            this.props.tickupComplete && this.props.tickupComplete(this.textObj);
        }
    }


    addText() {

    }

    backout(amount: number): any {
        return "backout";//(t: number) => (--t * t * ((amount + 1) * t + amount) + 1);
    }
    easeInSine(amount: number): any {
        return "easeInSine";//(x: number) => 1 - Math.cos((x * Math.PI) / 2);
    }


    fitText() {

        if (this.props.textType === "BitMapText") {
            var measuredWidth = 0;
            if (this.props.scaleToFit === true && this.props.width > 0) {
                measuredWidth = this.textObj.getLocalBounds().width;
                while (measuredWidth > this.props.width) {
                    let newStyle = this.textObj.style;
                    newStyle.fontSize -= 1;
                    // this.textObj.textStyle = newStyle;
                    this.textObj.fontSize = newStyle.fontSize;
                    measuredWidth = this.textObj.getLocalBounds().width;
                    if (newStyle.fontSize === this.textObj.minFontSize) {
                        break;
                    }
                }
            }
        } else {
            var measuredWidth = 0;
            if (this.props.scaleToFit === true && this.props.width > 0) {
                measuredWidth = this.textObj.getLocalBounds().width;
                while (measuredWidth > this.props.width) {
                    let newStyle = this.textObj.style;
                    newStyle.fontSize -= 1;
                    this.textObj.textStyle = newStyle;
                    measuredWidth = this.textObj.getLocalBounds().width;
                    if (newStyle.fontSize === this.textObj.minFontSize) {
                        break;
                    }
                }
            }
        }

    }

    createtext() {
        this.textObj.propsdata = this.props
        this.textObj.count = this.props.tickupvalue;
        this.textObj.tickupvalue = this.props.tickupvalue;
        this.textObj.runonvalue = this.props.runonvalue;
        this.textObj.skiptickup = this.props.skiptickup;
        this.textObj.tickuptime = this.props.tickuptime;
        // this.textObj.finalValue = this.stopTickup();
        //  this.textObj.startTicKup = this.startTickup(this.textObj.finalValue);
        this.textObj.objectInstance = this;
        this.reset();
        // setTimeout(() => {
        //     // this.textObj.skiptickup = true;
        //     this.startTickup(20000);
        // }, 20000)
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.tickupRequest);
    }

    private tweenTo(object: any, property: any, target: any, time: any, easing: any, onchange: any, oncomplete: any, start?: number) {
        let Tweenlist = new Tween(
            [object],
            {

                [property]: { start: object[property], end: target }
            },
            time / 1000,
            easing,
            false, null, null, null, null, false, onchange, oncomplete
        );
        // const tween: any = {
        //     object,
        //     property,
        //     propertyBeginValue: object[property],
        //     target,
        //     easing,
        //     time,

        //     change: onchange,
        //     complete: oncomplete,
        //     start: start || Date.now(),
        // };

        this.tweening.push(Tweenlist);
        // const tween: any = {
        //     object,
        //     property,
        //     propertyBeginValue: object[property],
        //     target,
        //     easing,
        //     time,

        //     change: onchange,
        //     complete: oncomplete,
        //     start: start || Date.now(),
        // };

        // this.tweening.push(tween);
        // return tween;
    }

    tick = () => {


        this.tickupRequest = requestAnimationFrame(this.tick);
        // const now = Date.now();
        // const remove = [];
        // const elapsed = now - this.then;
        // //this.fpsInterval
        // if (elapsed > this.fpsInterval) {
        //     this.then = now - (elapsed % this.fpsInterval);


        // for (let i = 0; i < this.tweening.length; i++) {
        //     const t = this.tweening[i];
        //     // this.textObj.tickupvalue = this.props.tickupvalue;
        //     // this.textObj.runonvalue = this.props.runonvalue;

        //     if (t.object.runonvalue) {
        //         const phase = Math.min(t.object.tickupvalue, (now - t.start) / t.time);

        //         // t.object[t.property] = this.lerp(t.propertyBeginValue, t.target, t.easing(phase));
        //         if (t.change) t.change(t);
        //         if (t.object.value >= t.target || t.object.skiptickup) {
        //             // if (phase === this.textObj.tickupvalue) {
        //             t.object[t.property] = t.target;
        //             if (t.complete) t.complete(t);
        //             remove.push(t);
        //         }
        //     } else {
        //         const phase = Math.min(1, (now - t.start) / t.time);

        //         t.object[t.property] = this.lerp(t.propertyBeginValue, t.target, t.easing(phase));
        //         if (t.change) t.change(t);
        //         if (phase === 1 || t.object.skiptickup) {
        //             t.object[t.property] = t.target;
        //             if (t.complete) t.complete(t);
        //             remove.push(t);
        //         }
        //     }

        // }
        // for (let i = 0; i < remove.length; i++) {
        //     this.tweening.splice(this.tweening.indexOf(remove[i]), 1);
        // }
        //}
    }

    lerp(a1: number, a2: number, t: number) {
        return a1 * (1 - t) + a2 * t;
    }

    render() {
        if (this.props.textType === "BitMapText") {
            return (<BitmapText ref={i => {
                this.props.addRef(this.props.name || this.props.id, i);
                return this.textObj = i;
            }} text={this.props.langObj[this.props.text] || this.props.text}
                name={this.props.name}
                style={this.props.textStyle}
                anchor={this.props.anchor || [0.5, 0.5]} x={this.props.x} visible={this.props.visible || false}
                y={this.props.y}></BitmapText>)
        }
        return (<Text ref={i => {
            this.props.addRef(this.props.name, i);
            return this.textObj = i;
        }} text={this.props.langObj[this.props.text] || this.props.text}
            name={this.props.name}
            style={this.props.textStyle}
            anchor={this.props.anchor} x={this.props.x} visible={this.props.visible || false}
            y={this.props.y}></Text>)
    }

}

export default UINumberText;